module.exports = __webpack_public_path__ + "img/icon35.5775fcec.png";